<template>
  <main>
    <wl-banner bgUrl='/static/img/product/kszr/banner.png' :bannerData='bannerData' paddingTop='214px'></wl-banner>
    <breadcrumb></breadcrumb>
    <section class="page1 bg" v-lazy:background-image="'/static/img/product/kszr/bg1.png'">
      <article class="container flex">
        <wl-title :title='page1Data.title' :desc='page1Data.desc' class="mytitle"></wl-title>
      </article>
    </section>
    <section class="page2 bg" v-lazy:background-image="'/static/img/product/kszr/p1.png'">
    </section>
    <section class="page3 bg" v-lazy:background-image="'/static/img/product/bg-cptx-1003.png'">
      <article class="container">
        <wl-title title='产品特性' :isNeedDesc=false></wl-title>
        <section class="flexWrap">
          <section class="box" v-for="(item,index) in page3Data" :key="item.key" @mouseenter="mouseEnter(index)" @mouseleave="page3HoverId = null">
            <section class="_icon " :style="page3HoverId===index?`background-position: -${72+144*index}px 0px;`:`background-position: -${144*index}px 0px;`"></section>
            <h3>{{item.title}}</h3>
            <p>{{item.desc}}</p>
          </section>
        </section>
      </article>
    </section>
    <submit-page></submit-page>
  </main>
</template>

<script>
export default {
  name: 'kszhunruManageSystem',
  data() {
    return {
      bannerData: {
        title: '实验室安全教育考试准入管理系统',
        desc: '建立严格准入机制\n提高安全技能和安全意识\n有效规范安全行为'
      },
      page1Data: {
        title: '实验室安全教育考试准入管理系统',
        desc: '实验室安全教育考试准入管理系统，是提高实验室安全管理水平、师生安全知识及事故应急处置能力的有效途径，用信息化的手段讲实验室安全知识练习、测试和考试进行系统性整合，只有考试通过颁发合格证书，才能进入实验室进行实验操作。'
      },
      page3Data: [
        { key: 'kszr-icon1', title: '统一学习平台', desc: '自带安全教育网站，内置大量安全知识，支持视频、文字、图片等多格式展示' },
        { key: 'kszr-icon2', title: '海量题库，方便学习', desc: '权威题库，内置五千多道试题\n题目类型多样，按需灵活配置' },
        { key: 'kszr-icon3', title: '灵活组卷，出题方便', desc: '多模式组卷，灵活采用随机和固定抽题，自由设置题目、时长、分数' },
        { key: 'kszr-icon4', title: '考试管理，精准投放', desc: '可指定考试部门、成员角色\n精准定位投放考试人员' },
        { key: 'kszr-icon5', title: '门禁联动，落实准入', desc: '考试结果自动生成，一键打印合格证书，与智能门禁联动，落实实验室准入机制' },
        { key: 'kszr-icon6', title: '多维度数据统计分析', desc: '可按部门、场次统计各种考试结果数据，方便管理员掌握学生学习情况' },
      ],
      page3HoverId: null,
    }
  },
  methods: {
    mouseEnter(index) {
      this.page3HoverId = index
    },
  }
}
</script>

<style lang='scss' scoped>
._icon {
  background: url("/static/img/product/kszr/icon.png");
}
main {
  background: #fbfbff;
}
h3 {
  font-size: 22px;
  font-weight: 500;
  color: #262626;
  line-height: 22px;
  padding-bottom: 12px;
  padding-top: 16px;
}
p {
  font-size: 20px;
  color: #8e8e8e;
  line-height: 30px;
  white-space: pre-line;
  text-align: left;
}
.pt-30 {
  padding-top: 32px !important;
}
.page1 {
  height: 545px;
  padding-top: 164px;
  text-align: left;
  .mytitle {
    width: 600px;
    margin-left: 660px;
    ::v-deep strong {
      color: #8e8e8e;
      line-height: 38px;
      padding-top: 23px;
    }
  }
}
.page2 {
  height: 842px;
}
.page3 {
  height: 1003px;
  padding-top: 136px;
  .flexWrap {
    padding: 0 150px;
    padding-top: 61px;
  }
  .box {
    width: 300px;
    height: 300px;
    background: #ffffff;
    border-radius: 14px;
    padding: 0 20px;
    padding-top: 47px;
    margin-bottom: 30px;
    ._icon {
      width: 72px;
      height: 72px;
      display: inline-block;
    }
    &:hover {
      background: linear-gradient(
        180deg,
        #cbe4ff 0%,
        rgba(59, 157, 255, 0.75) 100%
      );
      h3 {
        color: #fff;
      }
      p {
        color: #fff;
      }
    }
  }
}
</style>
